module.exports = __webpack_public_path__ + "static/img/docx.b8d90d83.png";